import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: `${theme.spacing(2)}px 0`,
  },

  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
  },

  refundButton: {
    background: '#dc3f53',
    color: '#ffff',
    '&:hover': {
      background: '#bf2236',
      color: '#ffff',
      transition: 'background-color 0.2s, box-shadow 0.3s',
    },
  },

  analyzeButton: {
    '&:hover': {
      transition: 'background-color 0.2s, box-shadow 0.3s',
    },
  },
}));

export default useStyles;
